function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m10.692 1.691 7.894 7.894a2 2 0 0 1 0 2.828l-6.172 6.172a2 2 0 0 1-2.828 0l-7.894-7.894a2 2 0 0 1-.57-1.662l.686-5.486a1.998 1.998 0 0 1 1.736-1.736l5.486-.686a2 2 0 0 1 1.662.57zM6.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgTag;